import {
  formatReceipt,
  formatReceiptText,
  type ReceiptOrder,
  type PaperWidth,
} from "@workspace/escpos";

export {
  formatReceipt,
  formatReceiptText,
  formatReceiptHTML,
  orderToReceipt,
  type ReceiptOrder,
  type ReceiptOrderItem,
} from "@workspace/escpos";

// Wrapper que escolhe entre ESC/POS RAW (CP858) e ASCII transliterado
// dependendo da capacidade da impressora. Térmicas baratas chinesas (VID
// 28E9 = YICHIP) não têm glyphs Latin-1 na ROM — acento vira lixo em
// qualquer codepage. Pra elas, `formatReceiptText` produz texto ASCII puro
// (sem acento, sem ESC/POS) que a impressora consegue renderizar.
// O caller obtém o flag asciiOnly de `useThermalPrinter().isAsciiOnlyPrinter`.
export function formatReceiptBytes(
  storeName: string,
  receipt: ReceiptOrder,
  paperWidth: PaperWidth,
  asciiOnly: boolean,
): Uint8Array {
  if (!asciiOnly) {
    return formatReceipt(storeName, receipt, paperWidth);
  }
  const text = formatReceiptText(storeName, receipt, paperWidth);
  // ASCII puro: charCodeAt produz bytes <= 0x7F idênticos. TextEncoder
  // (UTF-8) também daria o mesmo resultado, mas charCodeAt direto é
  // explicitamente single-byte e evita supresas com qualquer caractere que
  // o transliterador deixe escapar.
  const bytes = new Uint8Array(text.length);
  for (let i = 0; i < text.length; i++) bytes[i] = text.charCodeAt(i) & 0xFF;
  return bytes;
}
